import { jwtDecode } from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import RequestApi from "./module/company/requests/services";
import { Chip } from "@mui/material";

const SideNav = () => {
  const token = localStorage.getItem("token");
  const jwt = token ? jwtDecode(token) : null;
  //const jwt = jwtDecode(localStorage.getItem("token"));
  const role = jwt?.role[0]?.name;
  const menuSetting = useRef(false);
  const { t } = useTranslation();
  useEffect(() => {
    if (!menuSetting.current) {
      var script = document.createElement("script");
      var menuCode = `$(document).ready(function(){
        $("#menu").metisMenu()
      });`;
      script.innerHTML = menuCode;
      document.body.appendChild(script);
      menuSetting.current = true;
    }
  }, []);

  const [data, setData] = useState([]);

  const [timeZone, setTimeZone] = useState("");
  useEffect(() => {
    // Fetch the time zone
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(tz);
  }, []);

  useEffect(() => {
    // Fetch dashboard data when timeZone is available
    if (timeZone) {
      getWorkerRequest();
    }
  }, [timeZone]); //

  function getWorkerRequest() {
    debugger;
    RequestApi.getWorkerRequest(timeZone).then((respons) => {
      // const count =respons.data.data;
      setData(respons.data.data);
      console.log("getWorkerRequest", respons.data.data);
    });
  }

  console.log("countRequest", data.length);

  const companyMenu = [
    {
      path: "/dashboard/company/home",
      title: t("Home"),
      icon: "bi bi-house-door",
    },
    {
      path: "/dashboard/company/sites",
      title: t("Sites"),
      icon: "fadeIn animated bx bx-buildings",
    },

    {
      path: "/dashboard/company/workforce",
      title: t("Workforce"),
      icon: "lni lni-users",
    },
    {
      path: "/dashboard/company/wokers",
      title: t("Workers"),
      icon: "fadeIn animated bx bx-user-plus",
    },
    {
      path: "/dashboard/company/billing",
      title: t("Billing And Payment"),
      icon: "fadeIn animated bx bx-credit-card",
    },
    // {
    //   path: "/",
    //   title: "NFC Cards",
    //   icon: "fadeIn animated bx bx-mobile",
    // },
    // {
    //   path: "/dashboard/company/reports",
    //   title: "Reports",
    //   icon: "fadeIn animated bx bx-spreadsheet",
    // },

    {
      path: "/dashboard/company/subscriptions",
      title: t("Subscription"),
      icon: "fadeIn animated bx bx-file-blank",
    },
    {
      path: "/dashboard/company/messages",
      title: t("Messages"),
      icon: "fadeIn animated bx bx-message-square-detail",
    },
    {
      path: "/dashboard/company/requests",
      title: t("Requests"),
      icon: "fadeIn animated bx bx-bell",
      count: data?.length,
    },
    {
      path: "/dashboard/company/skill",
      title: t("Skills"),
      icon: "fadeIn animated bx bx-wrench",
    },

    {
      path: "/dashboard/company/settings",
      title: t("Settings"),
      icon: "lni lni-cog",
    },
    {
      path: "/dashboard/company/myProfile",
      title: t("My Profile"),
      icon: "fadeIn animated bx bx-user-circle",
    },
    // {
    //   path: "/",
    //   title: "Logout",
    //   icon: "fadeIn animated bx bx-log-out-circle",
    // },
  ];

  return (
    <>
      {jwt !== null ? (
        <aside className="sidebar-wrapper" data-simplebar="true">
          <div className="sidebar-header">
            <div>
              <a href={`/dashboard/company/home`}>
                <img
                  src="/assets/images/brand-logo-2.png"
                  className="logo-icon"
                  alt="logo icon"
                />
              </a>
            </div>
          </div>

          <ul className="metismenu" id="menu">
            {role === "ROLE_ADMIN"
              ? companyMenu.map((item, i) => (
                  <li key={i}>
                    <NavLink to={item.path}>
                      <div className="parent-icon">
                        <i className={item.icon}></i>
                      </div>
                      <div className="menu-title">
                        {item.title}

                        {item.count ? (
                          <Chip
                            label={item.count}
                            color="error"
                            size="small"
                            style={{ marginLeft: "60px" }}
                          />
                        ) : null}
                      </div>
                    </NavLink>
                  </li>
                ))
              : null}
          </ul>
        </aside>
      ) : null}
    </>
  );
};

export default SideNav;
